import * as React from 'react';

import { CalendarOutlined as CalendarToday } from '@ant-design/icons';
import { Button, Modal } from 'antd';

import { constants } from 'helpers';
import type { IUserData } from 'v2/interfaces/user';

interface IProps {
  user: IUserData;
}

function Consultancy({ user }: IProps) {
  const [openModal, setOpenModal] = React.useState(false);

  if (!user || !user?.wallet) return null;

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className='mb-2 flex flex-col justify-center gap-4 bg-white p-4'>
        <div className='flex items-center gap-4'>
          <img
            src='/img/icon-lightbulb.svg'
            alt='Icone Lâmpada'
            className='inline-block h-10 w-10 rounded-full bg-[#D9D9D9] p-[10px]'
          />
          <div className='flex flex-col'>
            <span className='m-0 text-base font-bold'>Precisa de visão estratégica?</span>
            <span className='m-0 text-sm font-normal text-gray-500'>
              Nossos analistas te guiam com insights e soluções da plataforma.
            </span>
          </div>
        </div>
        <Button
          className='border-border hover:bg-primary border font-normal hover:text-[#D9D9D9] hover:opacity-100'
          onClick={handleOpenModal}
          id='schedule-btn'
          icon={<CalendarToday />}
        >
          Agendar consultoria
        </Button>
        <Modal
          open={openModal}
          onCancel={handleCloseModal}
          footer={null}
          width={900}
          className='max-h-[900px]'
          styles={{ body: { height: '80vh' } }}
        >
          <iframe
            src={constants.HUBSPOT_WIDGET_URL}
            title='Consultoria'
            id='hubspot-widget'
            className='h-full w-full rounded-[3px] border-none'
          />
        </Modal>
      </div>
    </>
  );
}

export { Consultancy };
